// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3454) return "static/chunks/3454-63426e6503c1b419.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"757":"f8da22cd8790440e","1024":"1b334962e254acd9","3363":"70aa4dcf2e02839e","3653":"e759408f733b653f","4403":"afc8560119e4efa2","9844":"99cfb42e100a4a45"}[chunkId] + ".js";
};